import { createClient } from "@supabase/supabase-js";

const supabaseUrl = "https://mgexnkushdsdsnfjgedl.supabase.co";
const supabaseKey =
  "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Im1nZXhua3VzaGRzZHNuZmpnZWRsIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NjEyNTQ0MjUsImV4cCI6MjA3NjgzMDQyNX0.8lvDB4TtXweLfv64fZUSN4ZSZndbnvIYKEryrw5Sa-A";

const supabase = createClient(supabaseUrl, supabaseKey);

// ✅ Both named and default export (prevents import errors)
export { supabase };
export default supabase;
